import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { BREAKPOINTS } from '@/styles/theme';

const useStyles = createUseStyles(
  {
    right: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s8,
      flexShrink: 0, // Never shrink - navigation must stay visible
    },
    // Login button - visible on both desktop and mobile
    loginButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: [Spacings.s6, Spacings.s12],
      borderRadius: CornerRadius.r8,
      border: 'none',
      backgroundColor: PrimaryColors.base.default,
      color: '#ffffff',
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.semibold,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, transform 0.1s ease',
      WebkitTapHighlightColor: 'transparent',
      flexShrink: 0,
      whiteSpace: 'nowrap',
      '&:hover': {
        backgroundColor: PrimaryColors.base.action,
      },
      '&:active': {
        transform: 'scale(0.97)',
      },
      [`@media (max-width: ${BREAKPOINTS.smallMobile}px)`]: {
        padding: [Spacings.s4, Spacings.s8],
        fontSize: FontSizes.s12,
      },
    },
    // Mobile-only button - hidden on desktop via CSS
    generationsButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: CornerRadius.circle,
      border: 'none',
      backgroundColor: 'transparent',
      color: TextColors.base,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      WebkitTapHighlightColor: 'transparent',
      '&:hover': {
        backgroundColor: BackgroundColors.tint1,
      },
      '&:active': {
        transform: 'scale(0.95)',
      },
      // Hide on desktop - CSS handles responsive
      [`@media (min-width: ${BREAKPOINTS.desktop}px)`]: {
        display: 'none',
      },
    },
    // Close button - visible on all screen sizes
    settingsWrapper: {
      position: 'relative',
    },
    closeButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: CornerRadius.circle,
      border: 'none',
      backgroundColor: 'transparent',
      color: TextColors.tint1,
      cursor: 'pointer',
      transition: 'background-color 0.2s ease, color 0.2s ease',
      WebkitTapHighlightColor: 'transparent',
      '&:hover': {
        backgroundColor: BackgroundColors.tint1,
        color: TextColors.base,
      },
      '&:active': {
        transform: 'scale(0.95)',
      },
    },
  },
  { name: 'header-right' }
);

export default useStyles;
